module.exports = __webpack_public_path__ + "img/placeholder-logo.6b45dff0.svg";